import React from "react";
import { TimestampToDate } from "../../utils/timestampToDate.utils";

import {
  StyledReviewsPost,
  StyledReviewsPostAuthor,
  StyledReviewsPostContent,
  StyledReviewsPostDate
} from "./styled-reviews";

const ReviewItem = ({ review, className }) => {

  return (
    <StyledReviewsPost className={className && className}>
      <StyledReviewsPostAuthor>
        <span className="icon-quote1" />
        {review.client.firstname}
      </StyledReviewsPostAuthor>
      <StyledReviewsPostContent>
        {review.message}
      </StyledReviewsPostContent>
      <StyledReviewsPostDate>
        {TimestampToDate(review.createdAt)}
      </StyledReviewsPostDate>
    </StyledReviewsPost>
  );
};

export default ReviewItem;
